import React, { ChangeEvent } from "react";
import {
  Select,
  SelectChangeEvent,
  MenuItem,
  Divider,
  TextField,
} from "@mui/material";
import FilterPanel from "../../components/FilterPanel";
import { ServiceLevel } from "../../utils/enum/enum";
import { transformServiceLevelToString } from "../../utils/functions/functions";
import Label from "../../components/Label/Label";
import { InstanceFilters } from "../../utils/types/types";

type InstanceFilterPanelProps = {
  open: boolean;
  handleClose: () => void;
  filters: InstanceFilters;
  setFilters: (newFilters: InstanceFilters) => void;
}

export default function InstanceFilterPanel({
  open,
  handleClose,
  filters,
  setFilters
}: InstanceFilterPanelProps) {
  const {
    serviceLevel,
    version
  } = filters;

  const handleServiceLevelSelection = (event: SelectChangeEvent) => {
    const { target: { value }} = event;
    setFilters({
      ...filters,
      serviceLevel: value
    })
  }

  const handleVersionInput = (event: ChangeEvent<HTMLInputElement>) => {
    const { target: { value }} = event;
    setFilters({
      ...filters,
      version: value
    })
  }

  return (
    <FilterPanel
      open={open}
      handleClose={handleClose}
    >
      <Divider component="div" sx={{ mt: 2, mb: 2 }}/>
      <Label
        text="Version"
      />
      <TextField
        fullWidth
        id="version-input"
        name="version-input"
        value={version}
        onChange={handleVersionInput}
      />
      <Label
        text="Service Level"
      />
      <Select
        fullWidth
        displayEmpty
        labelId="service-level-select"
        id="service-level-select"
        onChange={handleServiceLevelSelection}
        defaultValue=""
        value={serviceLevel}
      >
        <MenuItem
          key="query-ordering-menuitem-default"
          value=""
        >
          Any
        </MenuItem>
        {Object.keys(ServiceLevel).map((key) => {
          const castKey = key as keyof typeof ServiceLevel
          const serviceLevel = ServiceLevel[castKey]
          return (
            <MenuItem key={`${serviceLevel}`} value={serviceLevel}>
              {transformServiceLevelToString(serviceLevel)}
            </MenuItem>
          )
        })}
      </Select>
    </FilterPanel>
  );
}